<template>
  <div class="locations">
    <div class="box-container" v-if="!$route.params.id">
      <div class="box-item" v-for="item in boxes">
        <router-link :to="'/locations/' + item.id">
          <img :src="item.img" />
          <p class="center">{{ item.title }}</p>
        </router-link>
      </div>
    </div>

    <div class="box-container" v-if="$route.params.id">
      <div class="box-item" v-for="item in boxes2[$route.params.id - 1]">
        <a :href="item.link">
          <img :src="item.img" />
        </a>

        <p class="center">{{ item.title }}</p>
      </div>

      <div class="footer">
        <v-btn
          class="footer-fab"
          fab
          elevation="3"
          @click.prevent="goBack"
          icon
        >
          <v-icon> mdi-keyboard-backspace </v-icon></v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
import firebase from "firebase";

export default {
  name: "Locations",
  components: {
    HorizontalScroll,
  },
  data() {
    return {
      boxes: [
        {
          title: "충청북도",
          img: "https://picsum.photos/120/168",
          id: 1,
        },
        {
          title: "충청남도",
          img: "https://picsum.photos/120/168",
          id: 2,
        },
        {
          title: "전라북도",
          img: "https://picsum.photos/120/168",
          id: 3,
        },
        {
          title: "전라남도",
          img: "https://picsum.photos/120/168",
          id: 4,
        },
        {
          title: "강원도",
          img: "https://picsum.photos/120/168",
          id: 5,
        },
        {
          title: "울산광역시",
          img: "https://picsum.photos/120/168",
          id: 6,
        },
        {
          title: "대구광역시",
          img: "https://picsum.photos/120/168",
          id: 7,
        },
        {
          title: "경상북도",
          img: "https://picsum.photos/120/168",
          id: 8,
        },
        {
          title: "경상남도",
          img: "https://picsum.photos/120/168",
          id: 9,
        },
        {
          title: "부산광역시",
          img: "https://picsum.photos/120/168",
          id: 10,
        },
        {
          title: "인천광역시",
          img: "https://picsum.photos/120/168",
          id: 11,
        },
        {
          title: "서울특별시",
          img: "https://picsum.photos/120/168",
          id: 12,
        },
        {
          title: "제주도",
          img: "https://picsum.photos/120/168",
          id: 13,
        },
      ],
      boxes2: [
        [
          // {
          //   title: "강남구",
          //   link: "https://jidobutton.com/p/ONEeBtJJV2Wub",
          //   img: "https://picsum.photos/120/168",
          // },
          // {
          //   title: "강동구",
          //   link: "https://naver.com",
          //   img: "https://picsum.photos/120/168",
          // },
          // {
          //   title: "강북구",
          //   link: "https://naver.com",
          //   img: "https://picsum.photos/120/168",
          // },
          // {
          //   title: "강서구",
          //   link: "https://naver.com",
          //   img: "https://picsum.photos/120/168",
          // },
          // {
          //   title: "관악구",
          //   link: "https://naver.com",
          //   img: "https://picsum.photos/120/168",
          // },
          // {
          //   title: "광진구",
          //   link: "https://naver.com",
          //   img: "https://picsum.photos/120/168",
          // },
          // {
          //   title: "구로구",
          //   link: "https://naver.com",
          //   img: "https://picsum.photos/120/168",
          // },
        ],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    firebase
      .firestore()
      .collection("posts1")
      .get()
      .then((snap) => {
        const testCollection = [];
        snap.forEach((doc, index) => {
          testCollection.push({ ...doc.data(), id: doc.id });
        });

        testCollection.sort((a, b) => {
          return a.order - b.order;
        });

        testCollection.forEach((item, index) => {
          if (item.location === "충청북도") {
            this.boxes2[0].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "충청남도") {
            this.boxes2[1].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "전라북도") {
            this.boxes2[2].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "전라남도") {
            this.boxes2[3].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "강원도") {
            this.boxes2[4].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "울산광역시") {
            this.boxes2[5].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "대구광역시") {
            this.boxes2[6].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "경상북도") {
            this.boxes2[7].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "경상남도") {
            this.boxes2[8].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "부산광역시") {
            this.boxes2[9].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "인천광역시") {
            this.boxes2[10].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "서울특별시") {
            this.boxes2[11].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          } else if (item.location === "제주도") {
            this.boxes2[12].push({
              title: item.contents,
              link: item.link,
              img: item.thumbnail,
            });
          }
        });
      });

    firebase
      .firestore()
      .collection("locations")
      .get()
      .then((snap) => {
        const testCollection = [];

        snap.forEach((doc, index) => {
          testCollection.push({ ...doc.data(), id: doc.id });
        });

        testCollection.forEach((item, index) => {
          if (item.cityName === "충청북도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "충청남도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "전라북도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "전라남도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "강원도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "울산광역시") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "대구광역시") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "경상북도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "경상남도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "부산광역시") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "인천광역시") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "서울특별시") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          } else if (item.cityName === "제주도") {
            var tempObj = { ...this.boxes[index], img: item.thumbnail };
            this.$set(this.boxes, index, tempObj);
          }
        });
      });
  },
};
</script>

<style scoped>
.box-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.box-item {
  width: 170px;
  height: 228px;
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 60px;
  box-shadow: 0px 1px 7px 0px #cbcbcb;
  border-radius: 20px;
}

@media (min-width: 350px) {
  .box-item:nth-child(1):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(2),
  .box-item:nth-child(2):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(3),
  .box-item:nth-child(2):nth-last-child(2),
  .box-item:nth-child(3):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item {
    width: 98px;
    height: 138px;
    margin-bottom: 60px;
  }
}

@media (min-width: 370px) {
  .box-item:nth-child(1):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(2),
  .box-item:nth-child(2):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(3),
  .box-item:nth-child(2):nth-last-child(2),
  .box-item:nth-child(3):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-container {
    margin-left: 3%;
  }

  .box-item {
    width: 104px;
    height: 184px;
    margin-bottom: 60px;
    margin-right: 6px;
  }
}

@media (min-width: 400px) {
  .box-item:nth-child(1):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(2),
  .box-item:nth-child(2):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(3),
  .box-item:nth-child(2):nth-last-child(2),
  .box-item:nth-child(3):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item {
    width: 90px;
    height: 158px;
    margin-bottom: 60px;
  }
}

@media (min-width: 1080px) {
  .box-item:nth-child(1):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(2),
  .box-item:nth-child(2):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-item:nth-child(1):nth-last-child(3),
  .box-item:nth-child(2):nth-last-child(2),
  .box-item:nth-child(3):nth-last-child(1) {
    margin-bottom: 180px;
  }

  .box-container {
    margin-left: 10%;
  }

  .box-item {
    width: 171px;
    height: 228px;
    margin-bottom: 60px;
    margin-right: 12px;
  }
}

@media (min-width: 1920px) {
  .box-container {
    margin-left: 13%;
  }
}

.center {
  margin-top: 6px;
  text-align: center;
}

img {
  border-radius: 5px;
  width: 100%;
  height: 100%;
}

.inner-content {
  width: 50px;
  justify-content: center;
  align-items: center;
}

.inner-content:not(:first-of-type) {
  margin-left: 10px;
}

.content-desc {
  margin-top: 12.5px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.footer-fab {
  position: fixed;
  right: 15px;
  bottom: 15px;
  background-color: white !important;
}
</style>
